export const JOB_APPLICATION_STAGE_THEME = {
	internal_review: '#4E5BA6',
	presented: '#6172F3',
	client_assessment: '#7A5AF8',
	client_definition: '#4A1FB8',
	pre_hiring: '#7A5AF8',
	offer: '#4E5BA6',
	onboarding: '#293056',
	rejected_by_client: '#F63D68',
	rejected_by_recruiter: '#F63D68',
	rejected_by_manager: '#F63D68',
	on_hold_by_talent: '#FDB022',
	on_hold_by_candidate: '#FDB022',
	on_hold_by_client: '#FDB022',
	unresponsive: '#A4A7AE',
	not_interested: '#A4A7AE',
	hired: '#25BD9F'
};

export const getJobApplicationStageTheme = stage => ({
	color: JOB_APPLICATION_STAGE_THEME[stage] || '#717BBC'
});
